export function resetHeight() {
    const sections1 = Array.from(document.querySelectorAll('.pack-row'));
    const sections2 = Array.from(document.querySelectorAll('.plan-wrapper .row'));
    const sections3 = Array.from(document.querySelectorAll('.combo-carousel'));
    const sections4 = Array.from(document.querySelectorAll('.plan-wrapper.recommendation'));

    const resetHeightForElements = (sections: Element[], selector: string) => {
        sections.forEach(section => {
            const dynamic = Array.from(section.querySelectorAll(`.item ${selector}`));

            dynamic.forEach(element => {
                const closestItem = (element as HTMLElement).closest('.item');
                if (closestItem?.classList.contains('featured')) {
                    return; // Skip featured items
                }
                (element as HTMLElement).style.height = 'auto';
            });

            let maxHeight = 0;
            dynamic.forEach(element => {
                const closestItem = (element as HTMLElement).closest('.item');
                if (closestItem?.classList.contains('featured')) {
                    return; // Skip featured items
                }
                const paragraphHeight = (element as HTMLElement).offsetHeight;
                maxHeight = Math.max(maxHeight, paragraphHeight);
            });

            dynamic.forEach(element => {
                const closestItem = (element as HTMLElement).closest('.item');
                if (closestItem?.classList.contains('featured')) {
                    return; // Skip featured items
                }
                (element as HTMLElement).style.height = `${maxHeight}px`;
            });
        });
    };

    resetHeightForElements(sections1, '.top');
    resetHeightForElements(sections2, '.top');
    resetHeightForElements(sections4, '.top');
    resetHeightForElements(sections4, '.includes');
    resetHeightForElements(sections2, '.includes');
    resetHeightForElements(sections1, '.includes');
    resetHeightForElements(sections1, 'small');
    resetHeightForElements(sections2, 'small');
    resetHeightForElements(sections4, 'small');
    resetHeightForElements(sections1, '.price-wrap');
    resetHeightForElements(sections2, '.price-wrap');
    resetHeightForElements(sections4, '.price-wrap');
    resetHeightForElements(sections3, 'h4');
}

export const setImageHeightsForHomePage = () => {

        const minHeightElements = [
            document.getElementById('sliding-banner'),
            document.querySelector('.youtube-embed'),
            ...document.querySelectorAll('#sliding-banner .slides > li')
        ];
        
        minHeightElements.forEach(el => {
            if (el) el.style.minHeight = '480px';
        });
        
        if (window.matchMedia("(min-width: 1399px)").matches) {
            [
                ...document.querySelectorAll('.youtube-embed'),
                ...document.querySelectorAll('#sliding-banner .slides > li'),
                ...document.querySelectorAll('.video-wrap'),
                ...document.querySelectorAll('#sliding-banner .main-img')
            ].forEach(el => {
                if (el) el.style.height = '100%';
            });
            document.querySelectorAll('.video-responsive iframe').forEach(el => {
                if (el) el.style.maxHeight = '80vh';
            });
        } 
        else if (window.matchMedia("(max-width: 1399px) and (min-width: 991px)").matches) {
            [
                ...document.querySelectorAll('.youtube-embed'),
                ...document.querySelectorAll('#sliding-banner .slides > li'),
                ...document.querySelectorAll('.video-wrap'),
                ...document.querySelectorAll('#sliding-banner .main-img')
            ].forEach(el => {
                if (el) el.style.height = '100%';
            });
            document.querySelectorAll('.video-responsive iframe').forEach(el => {
                if (el) el.style.maxHeight = '550px';
            });
        } 
        else {
            [
                ...document.querySelectorAll('.youtube-embed'),
                ...document.querySelectorAll('#sliding-banner .slides > li'),
                ...document.querySelectorAll('.video-wrap'),
                ...document.querySelectorAll('#sliding-banner .main-img')
            ].forEach(el => {
                if (el) el.style.height = 'auto';
            });
            document.querySelectorAll('.video-responsive iframe').forEach(el => {
                if (el) el.style.maxHeight = 'none';
            });
        }
    };

export const ImageHeightSetterForBusinessPage = () => {
    const navbar = document.querySelector('.navbar');
    let headerHeight = 0;
    if (navbar) {
      const style = window.getComputedStyle(navbar);
      const marginTop = parseInt(style.marginTop) || 0;
      const marginBottom = parseInt(style.marginBottom) || 0;
      headerHeight = navbar.offsetHeight + marginTop + marginBottom;
    }

    const targetElements = [
      document.getElementById('sliding-banner'),
      ...document.querySelectorAll('.youtube-embed'),
      ...document.querySelectorAll('.main-img')
    ];
    targetElements.forEach(el => {
      if (el) el.style.minHeight = '450px';
    });

    const videoElements = [
      ...document.querySelectorAll('.video-responsive iframe'),
      ...document.querySelectorAll('.video-responsive video'),
      document.getElementById('single-banner')
    ];

    let heightCalc;
    if (window.matchMedia("(min-width: 1200px)").matches) {
      heightCalc = `87vh`;
    } else if (window.matchMedia("(max-width: 1199px) and (min-width: 576px)").matches) {
      heightCalc = `80vh`;
    } else {
      heightCalc = `82vh`;
    }


    const heightValue = `calc(${heightCalc} - ${headerHeight}px)`;
    targetElements.forEach(el => {
      if (el) el.style.height = heightValue;
    });
    videoElements.forEach(el => {
      if (el) el.style.maxHeight = heightValue;
    });
  };